import React from "react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useLang, pick } from "@/contexts/LanguageContext";

export default function ConditionsDrawer({ open, onClose, vehicle, settings }) {
  const { lang, t } = useLang();
  const vConditions = pick(vehicle?.conditionsText, lang);
  const gConditions = pick(settings?.rentalConditions, lang);

  const showDeposit = vehicle?.deposit && Number(vehicle.deposit) > 0;
  const showWeekly = vehicle?.priceWeekly && Number(vehicle.priceWeekly) > 0;
  const showMonthly = vehicle?.priceMonthly && Number(vehicle.priceMonthly) > 0;

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent
        side="right"
        data-testid="conditions-drawer"
        className="bg-[#0C0C0C] border-l border-[#2A2A2A] text-[#F5F1EB] w-full sm:max-w-md p-0 overflow-y-auto">
        <SheetTitle className="sr-only">{t.conditions.title}</SheetTitle>
        <div className="p-6 md:p-8 pb-20">
          <div className="text-overline text-[#C9A55A] mb-3">{t.conditions.title}</div>
          {vehicle?.name && <h3 className="font-display text-2xl md:text-3xl text-[#F5F1EB] mb-2">{vehicle.name}</h3>}

          {/* Pricing matrix */}
          <div className="mt-4 mb-6 grid grid-cols-3 gap-2 text-xs">
            <PriceBox label={t.booking.perDay} value={vehicle?.priceDaily ? `€${Math.round(vehicle.priceDaily)}` : "—"} highlight />
            <PriceBox label={t.booking.perWeek} value={showWeekly ? `€${Math.round(vehicle.priceWeekly)}` : "—"} />
            <PriceBox label={t.booking.perMonth} value={showMonthly ? `€${Math.round(vehicle.priceMonthly)}` : "—"} />
          </div>

          <div className="grid grid-cols-2 gap-3 text-xs mb-6">
            {showDeposit && <Mini label={t.booking.deposit} value={`€${Math.round(vehicle.deposit)}`} />}
            {vehicle?.fuelType && <Mini label="Fuel" value={vehicle.fuelType} />}
            {vehicle?.location && <Mini label={t.contact.location} value={vehicle.location} />}
          </div>

          {vConditions ? (
            <div className="mb-8">
              <div className="text-overline text-[#C9A55A] mb-3">{t.conditions.vehicleConditions}</div>
              <p className="text-sm text-[#F5F1EB]/80 font-light leading-relaxed whitespace-pre-line">{vConditions}</p>
            </div>
          ) : null}

          <div>
            <div className="text-overline text-[#C9A55A] mb-3">{t.conditions.globalConditions}</div>
            <p className="text-sm text-[#F5F1EB]/80 font-light leading-relaxed whitespace-pre-line">{gConditions}</p>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}

function PriceBox({ label, value, highlight }) {
  return (
    <div className={`border ${highlight ? "border-[#C9A55A]" : "border-[#2A2A2A]"} p-3 text-center`}>
      <div className="text-[10px] text-[#8A8A8A] tracking-[0.18em] uppercase">{label}</div>
      <div className={`font-display text-lg ${highlight ? "text-[#C9A55A]" : "text-[#F5F1EB]"}`}>{value}</div>
    </div>
  );
}
function Mini({ label, value }) {
  return (
    <div className="border border-[#2A2A2A] p-3">
      <div className="text-[10px] text-[#8A8A8A] tracking-[0.18em] uppercase">{label}</div>
      <div className="font-display text-[#F5F1EB] text-base">{value}</div>
    </div>
  );
}
